<template>
  <a-card :loading="loading" :bordered="false" :body-style="{padding: '0'}">
    <div class="salesCard">
      <a-tabs  size="large" :tab-bar-style="{marginBottom: '24px', paddingLeft: '16px'}">
        <div class="extra-wrapper" slot="tabBarExtraContent">
          <div class="extra-item">
            <a @click="getAllProductSoldRankingData()">{{ $t('message.views.workbench.all') }}</a>
            <a @click="getAllProductSoldRankingData('TODAY')">{{ $t('message.views.workbench.today') }}</a>
            <a @click="getAllProductSoldRankingData('THIS_WEEK')">{{ $t('message.views.workbench.thisWeek') }}</a>
            <a @click="getAllProductSoldRankingData('THIS_MONTH')">{{ $t('message.views.workbench.thisMonth') }}</a>
            <a @click="getAllProductSoldRankingData('THIS_QUARTER')">{{ $t('message.views.workbench.thisQuarter') }}</a>
          </div>
          <a-range-picker :style="{width: '256px'}" @change="onRankingDataDateChange"/>
        </div>

        <a-tab-pane loading="true" :tab="$t('message.views.workbench.productSold')" key="1" >
          <a-row>
            <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">
              <bar :data="productSoldData['ITEM_SOLD']" :title="$t('message.views.workbench.productSoldTendency')"
                   :scale="[{dataKey: 'num'}]"
                   :tooltip="['date*num',(date, num) => ({name: date,value: num})]"/>
            </a-col>
            <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
              <rank-list :title="$t('message.views.workbench.productSoldRank')" :list="rankingData['ITEM_SOLD']"/>
            </a-col>
          </a-row>
        </a-tab-pane>

        <a-tab-pane :tab="$t('message.views.workbench.orderQuantity')" key="2">
          <a-row>
            <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">
              <bar :data="productSoldData['ORDER_QUANTITY']" :title="$t('message.views.workbench.orderQuantityTendency')"
                   :scale="[ {dataKey: 'num'}]"
                   :tooltip="['date*num',(date, num) => ({name: date,value: num})]"/>
            </a-col>
            <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
              <rank-list :title="$t('message.views.workbench.orderQuantityRank')" :list="rankingData['ORDER_QUANTITY']"/>
            </a-col>
          </a-row>
        </a-tab-pane>

      </a-tabs>
    </div>
  </a-card>
</template>

<script>
import request from '../../../utils/request'
import {
  RankList,
  Bar
} from '../../../components'

const rankList = [
  {
    name: 'Mi10',
    total: 1221
  },
  {
    name: 'HuaweiP30',
    total: 1021
  }, {
    name: 'Iphone12',
    total: 961
  }, {
    name: 'T-shirt-red',
    total: 921
  }, {
    name: 'Cup-red',
    total: 341
  }, {
    name: 'Airplane',
    total: 2
  }, {
    name: 'Rocket',
    total: 1
  }
]

const barData = []
const barData2 = []
for (let i = 0; i < 12; i += 1) {
  barData.push({
    x: `${i + 1}月`,
    y: Math.floor(Math.random() * 1000) + 200
  })
  barData2.push({
    x: `${i + 1}月`,
    y: Math.floor(Math.random() * 1000) + 200
  })
}

export default {
  name: 'MonthlyProductSoldAndProductRanking',
  data () {
    return {
      barData,
      barData2,
      rankList,
      dateRange: 'TODAY',
      productSoldData: {
        ITEM_SOLD: [],
        ORDER_QUANTITY: []
      },
      rankingData: {
        ITEM_SOLD: [],
        ORDER_QUANTITY: []
      },
      loading: true
    }
  },
  components: {
    RankList,
    Bar
  },
  methods: {
    getProductSoldValue (productDataSoldType) {
      request({
        url: '/dashboard/monthlyProductSold',
        method: 'get',
        params: {
          productSoldDataType: productDataSoldType
        }
      }).then(response => {
        // response.data = json
        this.productSoldData[productDataSoldType] = response.data.model.map((item) => {
          return {
            date: item.date,
            num: parseInt(item.num)
          }
        })
        console.log('productSoldData', this.productSoldData)
      })
    },
    getAllProductSoldRankingData (dateRange, startTime, endTime) {
      this.getProductSoldRanking('ITEM_SOLD', dateRange, startTime, endTime)
      this.getProductSoldRanking('ORDER_QUANTITY', dateRange, startTime, endTime)
    },
    getProductSoldRanking (productDataSoldType, dateRange, startTime, endTime) {
      request({
        url: '/dashboard/productSoldRanking',
        method: 'get',
        params: {
          productDataSoldType: productDataSoldType,
          dateRange: dateRange,
          startDate: startTime,
          endDate: endTime
        }
      }).then(response => {
        // response.data = json
        this.rankingData[productDataSoldType] = response.data.model.map((item) => {
          return {
            name: item.name,
            total: parseInt(item.value)
          }
        })
        console.log('rankingData', this.rankingData)
      })
    },
    onRankingDataDateChange (date, dateStr) {
      console.log('onRankingDataDateChange', date, dateStr)
      this.getAllProductSoldRankingData(null, dateStr[0], dateStr[1])
    }
  },
  mounted () {
    this.getProductSoldValue('ITEM_SOLD')
    this.getProductSoldValue('ORDER_QUANTITY')
    this.getAllProductSoldRankingData()
    setTimeout(() => {
      this.loading = !this.loading
    }, 1000)
  }
}
</script>

<style lang="less" scoped>
.extra-wrapper {
  line-height: 55px;
  padding-right: 24px;

  .extra-item {
    display: inline-block;
    margin-right: 24px;

    a {
      margin-left: 24px;
    }
  }
}

.antd-pro-pages-dashboard-analysis-twoColLayout {
  position: relative;
  display: flex;
  display: block;
  flex-flow: row wrap;
}

.antd-pro-pages-dashboard-analysis-salesCard {
  height: calc(100% - 24px);
  /deep/ .ant-card-head {
    position: relative;
  }
}

.dashboard-analysis-iconGroup {
  i {
    margin-left: 16px;
    color: rgba(0,0,0,.45);
    cursor: pointer;
    transition: color .32s;
    color: black;
  }
}
.analysis-salesTypeRadio {
  position: absolute;
  right: 54px;
  bottom: 12px;
}
.todo-container{
  margin: 20px 0 20px 0;
  background-color: white;
}

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/components/MonthlyProductSoldAndProductRanking.vue